import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { config } from '@/config';
import ar from './locales/ar.json';
import en from './locales/en.json';

export const RTL_LOCALES = new Set(['ar']);
export const isRtl = (locale: string) => RTL_LOCALES.has(locale);

void i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, ar: { translation: ar } },
  lng: config.defaultLocale,
  fallbackLng: config.defaultLocale,
  supportedLngs: config.supportedLocales,
  interpolation: { escapeValue: false },
});

/** Keeps <html lang/dir> in step with the active locale. */
export function applyLocaleToDocument(locale: string) {
  document.documentElement.lang = locale;
  document.documentElement.dir = isRtl(locale) ? 'rtl' : 'ltr';
}

export default i18n;
